import Delete from "./Delete"

export default function CkQuestionEditor({
  title,
  color,
  className,
  answerBody,
  deleteOption,
  answerOptions,
  answerOptionID,
  editorDisabled,
  setAnswerOptions,
  name
}) {

  return (
    <>
      <div className={`w-full rounded-[14px] bg-white ${className}`}>
        <div
          className={`flex justify-between rounded-t-[14px] ${color} px-5 py-2.5 text-white`}
        >
          <p className="mx-auto">{title}</p>
          {deleteOption && (
            <Delete
              answerOptionsId={answerOptionID}
              setAnswerOptions={setAnswerOptions}
              answerOptions={answerOptions}
            />
          )}
        </div>
        {!editorDisabled && (
          <div className="form-group">
            <textarea 
              className="form-control" 
              name={name} 
              id={name} 
              defaultValue={answerBody} 
            />
          </div>
        )}
      </div>
    </>
  )
}
